import axios from 'axios';
import { getCurrentLanguage } from '../utils/languageUtils';
import { clearRoleContextCache } from './roleContext.service';
import { clearUpcomingMeetingsCache } from './meetingsIndicator.service';
import { clearInvigilatorCentersCache } from '../utils/qhlsInvigilator';

const API_URL = 'https://guide.msoftit.com/api/'; //Production
// const API_URL = 'http://127.0.0.1:8000/api/'; //Demo

class AuthService {

  // Helper method to get current language
  getCurrentLanguage() {
    return getCurrentLanguage();
  }

  login(user) {
    return axios
      .post(API_URL + 'login', {
        mobile: user.mobile,
        country_code: user.country_code,
        username: user.username,
        password: user.password,
        fcm: user.fcm,
        language: this.getCurrentLanguage()
      })
      .then(response => {
        if (response.data.user.accessToken) {
          // Store user data in secure cookie
          this.setCookie('user', response.data.user);
          
          // Force remove from localStorage if it exists
          localStorage.removeItem('user');
        }
        return response.data.user;
      });
  }

  userLogin(user) {
    return axios
      .post(API_URL + 'userLogin', {
        mobile: user.mobile,
        code: user.code,
        username: user.username,
        password: user.pin,
        fcm: user.fcm,
        language: this.getCurrentLanguage()
      })
      .then(response => {
        if (response.data.user.accessToken) {
          // Store user data in secure cookie
          this.setCookie('user', response.data.user);
          
          // Force remove from localStorage if it exists
          localStorage.removeItem('user');
        }
        return response.data.user;
      });
  }

  logout() {
    // Remove authentication cookies
    this.removeCookie('user');
    this.removeCookie('currentAdminLevel');
    localStorage.removeItem('user');
    localStorage.removeItem('currentAdminLevel');
    // Session caches are keyed to the logged-in user — drop them on logout
    localStorage.removeItem('my_profile');
    clearRoleContextCache();
    clearUpcomingMeetingsCache();
    clearInvigilatorCentersCache();
  }

  register(data) {
    const requestWithLanguage = { ...data, language: this.getCurrentLanguage() };
    return axios.post(API_URL + 'register', requestWithLanguage);
  }

  getOtp(data) {
    const requestWithLanguage = { ...data, language: this.getCurrentLanguage() };
    return axios.post(API_URL + 'getOtp', requestWithLanguage);
  }

  // Helper methods
  setCookie(name, value, days = 180) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    const secure = window.location.protocol === 'https:' ? '; secure' : '';
    document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; ${expires}; path=/${secure}; samesite=lax`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}

export default new AuthService();
